import SvgIcon from '@mui/material/SvgIcon';
import type { SVGIcon } from '../SVGIcon';
import { SVGStyles } from '../SVGStyles';

export const MobileIcon = ({ height = 18, 'data-test': dataTest }: Readonly<SVGIcon>) => {
  return (
    <SvgIcon viewBox="0 -960 960 960" data-test={dataTest} sx={{ ...SVGStyles, width: 18, height }}>
      <path d="M280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v124q18 7 29 22t11 34v80q0 19-11 34t-29 22v404q0 33-23.5 56.5T680-40H280Zm0-80h400v-720H280v720Zm0 0v-720 720Zm200-600q17 0 28.5-11.5T520-760q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760q0 17 11.5 28.5T480-720Z" />
    </SvgIcon>
  );
};
